import UserRolesEnum from '../enums/UserRolesEnum'

export default {
    props: {
        physician: { type: Object, required: true },
    },

    computed: {
        isPhysician() {
            return this.physician.practice && this.physician.practice.locations
        },
        isPhysicianCompletedRegistration() {
            return this.physician.isSignupFinished || (this.physician.target && this.physician.target.isRegistrationComplete)
        },
        practiceLocations() {
            const locations = this.isPhysician
                ? this.$get(this.physician, 'practice.locations', [])
                : this.$get(this.physician, 'locations', [])

            return locations
        },
        practiceId() {
            return this.isPhysician ? this.physician.practice?.id : this.physician?.id
        },
        ctaProps() {
            if (this.isPhysicianCompletedRegistration) {
                return {
                    is: 'card-availability',
                    physician: this.physician,
                    practiceId: this.practiceId,
                    locations: this.practiceLocations,
                }
            } else if (!this.physician.target || this.physician.target.dateJoined) {
                return {
                    is: 'card-contact-details',
                    physician: this.physician,
                    locations: this.practiceLocations,
                }
            }
        },

        ctaInnerModalProps() {
            return {
                ...this.ctaProps,
                showDirectReferralAsInnerModal: true,
            }
        },

        ctaMasterUserProps() {
            const activeMember = this.$auth.getActiveMember()
            const user = this.$auth.getUser()

            if (activeMember?.id === this.physician?.id || this.physician.userRole?.id !== UserRolesEnum.PHYSICIAN.ID) return

            if (this.isPhysicianCompletedRegistration) {
                if (activeMember.userRole?.id === UserRolesEnum.PHYSICIAN.ID) {
                    return {
                        is: 'card-availability',
                        physician: this.physician,
                        practiceId: this.practiceId,
                        locations: this.practiceLocations,
                    }
                }
            } else if (!this.physician.isAvailabilitySet && user.canModifyPracticeMemberAvailability) {
                return { is: 'card-set-availability', physician: this.physician }
            } else if (this.physician.isAvailabilitySet) {
                return {
                    is: 'card-contact-details',
                    physician: this.physician,
                    locations: this.practiceLocations,
                }
            }
        },
    },
}
